export default defineNuxtPlugin((nuxtApp) => {
  const theme = useCookie<'dark' | 'light'>('theme')
  if (import.meta.client) {
    document.documentElement.classList.toggle('dark', theme.value === 'dark')
  }
  else {
    nuxtApp.payload.theme = theme.value
  }
})
